const config = {
    BASEURL: process.env.VITE_APP_CONTEXT_PATH
}
export default config;